import { render, staticRenderFns } from "./TokenRecovery.vue?vue&type=template&id=18802c16&scoped=true&"
import script from "./TokenRecovery.vue?vue&type=script&lang=js&"
export * from "./TokenRecovery.vue?vue&type=script&lang=js&"
import style0 from "./TokenRecovery.vue?vue&type=style&index=0&id=18802c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18802c16",
  null
  
)

export default component.exports